import { FILTER_FIELD_TYPES } from '../../ui/data/filters/filterTypes';

export const TEST_CYCLE_FILTER_DEFAULTS = {
  status: 'All',
  owner: [],
  purpose: 'All',
  type: 'All',
  platforms: [],
  subPlatforms: [],
  browsers: [],
  geographies: [],
  languages: [],
  cloudDevice: [],
};
export function buildTestCycleFilterConfig() {
  return [
    {
      key: 'status',
      label: 'Status',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
    {
      key: 'owner',
      label: 'Owner',
      type: FILTER_FIELD_TYPES.MULTI_SELECT,
      defaultValue: [],
      gridSize: 6,
      placeholder: 'Select owners',
    },
    {
      key: 'purpose',
      label: 'Purpose',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
    {
      key: 'type',
      label: 'Test Cycle Type',
      type: FILTER_FIELD_TYPES.SELECT,
      defaultValue: 'All',
      gridSize: 6,
    },
  ];
}
